import React from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { MANAGER_FEE_LIST_QUERY } from "../Queries";
import { Panel, PanelHeader, PanelBody } from "../../../Components/Panel/Panel";

export default withRouter(({ location }) => {
  const { data, loading } = useQuery(MANAGER_FEE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  if (loading || !data || !data.ManagerFeeList) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  const fees = data.ManagerFeeList;

  return (
    <>
      <Helmet>
        <title>담당 회비 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item active">담당 회비</li>
        </ol>
        <h1 className="page-header">담당 회비</h1>

        <Panel>
          <PanelHeader noButton={true}>담당 회비 목록</PanelHeader>
          <PanelBody className="p-0">
            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>회비명</th>
                    <th>주관</th>
                    <th style={{ width: 300 }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {fees.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-center">
                        담당하는 회비가 없습니다.
                      </td>
                    </tr>
                  )}
                  {fees.map((fee) => (
                    <tr key={fee.id}>
                      <td>{fee.title}</td>
                      <td>{fee.planner}</td>
                      <td>
                        <Link
                          to={`/manager/fees/${fee.id}/edit${location.search}`}
                          className="btn btn-white btn-xs m-r-5"
                        >
                          <i className="fa fa-info-circle m-r-5"></i>정보
                        </Link>
                        <Link
                          to={`/manager/fees/${fee.id}/users${location.search}`}
                          className="btn btn-white btn-xs text-green m-r-5"
                        >
                          회원
                        </Link>
                        <Link
                          to={`/manager/fees/${fee.id}/ledgers${location.search}`}
                          className="btn btn-white btn-xs text-green m-r-5"
                        >
                          내역
                        </Link>
                        <Link
                          to={`/manager/fees/${fee.id}/taxInfos${location.search}`}
                          className="btn btn-white btn-xs text-blue"
                        >
                          소득공제신고 내역
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </>
  );
});
